<ig-loader size="fullscreen" *ngIf="fullSizeLoading"></ig-loader>
<div class="viewport">
  <ig-layout-header [logoLink]="['/Dashboard']">
    <ng-template igLayoutHeaderMainContent>
      <div class="headline">Partner Panel</div>
    </ng-template>

    <ng-template igLayoutHeaderRightContent>
      <div class="languages">
        <a (igA11yLink)="selectLanguage('de')" [class.active]="currentLanguage === 'de'">DE</a>
        <a (igA11yLink)="selectLanguage('en')" [class.active]="currentLanguage === 'en'">EN</a>
      </div>
    </ng-template>
  </ig-layout-header>


  <div class="stage">
    <div class="login-card-container">
      <div class="login-card center">

          <div class="login-card__inner" *ngIf="isTicketValidationLogin || !isProduction">

              <div class="login-icon">
                <i class="icon-a050_login"></i>
              </div>

              <h3>{{ 'login_yourself' | translate }}</h3>

              <form class="login-form" (ngSubmit)="onSubmit()">
                <div class="p-fluid p-grid">
                  <div class="p-col-12">
                    <span class="p-float-label p-input-icon-right">
                      <i *ngIf="emailField.valid" class="pi pi-check"></i>
                      <i
                        *ngIf="emailField.invalid && emailField.dirty && emailField.touched"
                        class="pi pi-times is-invalid-icon"
                        [igTooltip]="getErrorMessage('emailField')"
                      ></i>
                      <input
                        [placeholder]="'email_placeholder' | translate"
                        [(ngModel)]="loginModel.email"
                        required
                        name="first_name"
                        #emailField="ngModel"
                        #emailNode
                        email
                        type="email"
                        id="email"
                        class="p-inputtext-lg"
                        pInputText
                      />
                      <label for="inputtext">{{ 'email' | translate }}</label>
                    </span>
                  </div>

                  <div class="p-col-12">
                    <span class="p-float-label p-input-icon-right">
                      <i *ngIf="passwordField.valid" class="pi pi-check"></i>
                      <i
                        *ngIf="passwordField.invalid && passwordField.dirty && passwordField.touched"
                        class="pi pi-times is-invalid-icon"
                        [igTooltip]="getErrorMessage('passwordField')"
                      ></i>
                      <input
                        #passwordField="ngModel"
                        #passwordNode
                        minlength="8"
                        [placeholder]="'password_placeholder' | translate"
                        [(ngModel)]="loginModel.password"
                        required
                        name="password"
                        type="password"
                        id="password"
                        class="p-inputtext-lg"
                        pPassword
                        [feedback]="false"
                      />
                      <label for="inputtext">Password</label>
                    </span>
                  </div>

                  <div *ngIf="showOTP" class="p-col-12">
                    <span class="p-float-label p-input-icon-right">
                      <i *ngIf="otpField.valid" class="pi pi-check"></i>
                      <i *ngIf="otpField.invalid && otpField.dirty && otpField.touched"
                         class="pi pi-times is-invalid-icon"
                         [igTooltip]="getErrorMessage('otpField')"
                      ></i>
                      <input
                        [placeholder]="'2fa_placeholder' | translate"
                        (ngModelChange)="otpchange($event)"
                        [(ngModel)]="loginModel.otp"
                        maxlength="6"
                        minlength="6"
                        pattern="^[0-9]{6}$"
                        required
                        name="otp"
                        #otpField="ngModel"
                        #otpNode
                        type="text"
                        id="otp"
                        class="p-inputtext-lg"
                        pInputText
                      />
                      <label for="inputtext">{{ '2fa' | translate }}</label>
                    </span>
                  </div>
                </div>

                <div class="p-fluid p-grid">
                  <div class="p-col-12">
                    <ig-button
                      class="ui-button-success"
                      e2e="btn-login"
                      type="submit"
                      role="submit"
                      [loading]="(isLoggingIn$ | async) || false"
                      [disabled]="(isLoggingIn$ | async) || emailField.invalid || passwordField.invalid || otpField?.invalid"
                      [label]="'login' | translate"
                      [style]="{ width: '100%' }"
                    ></ig-button>
                    <div *ngIf="loginErrorMessage && loginErrorMessage.length > 0" class="p-pt-3">
                      <ig-inline-alert *ngFor="let message of loginErrorMessage" [severity]="message.severity"
                      ><strong>{{ message.summary }}</strong
                      ><br/>{{ message.detail }}</ig-inline-alert
                      >
                    </div>
                  </div>
                </div>
              </form>

          </div>

          <div class="login-card__inner" *ngIf="!isTicketValidationLogin && isProduction">
            <div class="p-pt-2">
              <ig-inline-alert *ngIf="currentLanguage === 'de'" severity="warning">
                <strong>Deprecation Notice</strong>
                <br/>Um das Produkt weiter zu verbessern, haben wir den Login Bereich für das Partner- und das
                Cloud-Panel zusammengeführt.<br/><br/>
                Seit dem <u>01.09.2022</u> kannst du dich nur noch über den Cloud-Panel-Login-Bereich anmelden und das
                Partner-Panel ist unter &lt;cloud.panel.url&gt;/Access/
                erreichbar.<br/><br/>
                <a target="_blank" href="https://gridscale.io/blog/maschinenraum-august-2022/">Mehr Informationen zum
                  Update.</a>
              </ig-inline-alert>
              <ig-inline-alert *ngIf="currentLanguage !== 'de'" severity="warning">
                <strong>Deprecation Notice</strong>
                <br/>To further improve the product we've merged the partner and cloud panel login
                applications.<br/><br/>
                From the <u>01.09.2022</u> you are only able to login via your cloud panel login area and the partner
                panel has moved behind &lt;cloud.panel.url&gt;/Access/
                <br/><br/>
                <a target="_blank" href="https://gridscale.io/en/blog/the-machine-room-q2-22/">You can read more about
                  the update here.</a>
              </ig-inline-alert>
            </div>
          </div>

      </div>
      <div class="footer">
        <a href="https://gridscale.io/impressum/" >{{ 'imprint' | translate }}</a> |
        <a href="https://gridscale.io/datenschutzcenter/datenschutzerklaerung/" >{{ 'privacy_statement' | translate }}</a>
      </div>
    </div>
  </div>
</div>
